/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Active_Mean_Mare_FallInputs */

const fr_active_mean_mare_fall = /** @type {(inputs: Active_Mean_Mare_FallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilité`)
};

/**

* @param {Active_Mean_Mare_FallInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const active_mean_mare_fall = /** @type {((inputs?: Active_Mean_Mare_FallInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_Mean_Mare_FallInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_active_mean_mare_fall(inputs)
});